import script from "./LegoInventory.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegoInventory.vue?vue&type=script&setup=true&lang=ts"

export default script